import { Box, styled, Button } from "@mui/material";
import blur from "../../../images/bizdevBlur.png";
import blurTwo from "../../../images/blurTwo.png";

const StartFreelancing = ({
  setOpen,
}: {
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
}) => {
  return (
    <GradientContainer>
      <Root>
        <img
          src={blur}
          alt=""
          style={{
            position: "absolute",
            width: "100%",
            top: 0,
            height: "100%",
          }}
        />
        <img
          src={blurTwo}
          alt=""
          style={{
            position: "absolute",
            width: "100%",
            top: 0,
            height: "100%",
          }}
        />
        <h1>Ready to Start Freelancing?</h1>
        <p>
          Get access to a private Discord channel with mentors, peers, and past
          interns. <br /> Spaces are limited — secure your spot today.
        </p>
        <StyledButton variant="contained" onClick={() => setOpen(true)}>
          Apply Now
        </StyledButton>
      </Root>
    </GradientContainer>
  );
};

export default StartFreelancing;

const GradientContainer = styled(Box)(({ theme }) => ({
  background: "#19191B",
  height: "438px",
  maxWidth: "1200px",
  display: "flex",
  margin: "auto",
  alignItems: "center",
  justifyContent: "center",
  position: "relative",
  borderRadius: "20px",
  overflow: "hidden",
  [theme.breakpoints.down(900)]: {
    borderRadius: "0px",
  },
  [theme.breakpoints.down(720)]: {
    height: "520px",
  },
}));

const Root = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  textAlign: "center",
  width: "831px",
  maxWidth: "100%",
  gap: "20px",
  margin: "auto",
  color: "#fefefe",

  "&>h1": {
    fontSize: "36px",
    lineHeight: "52px",
    fontWeight: 700,
    [theme.breakpoints.down(720)]: {
      width: "100%",
      paddingInline: "20px",
      fontSize: "30px",
      lineHeight: "45px",
    },
  },
  "&>p": {
    fontSize: "16px",
    lineHeight: "24px",
    fontWeight: 500,
    width: "588px",
    [theme.breakpoints.down(600)]: {
      width: "100%",
    },
    [theme.breakpoints.down(500)]: {
      fontSize: "16px",
      lineHeight: "24px",
      fontWeight: 500,
    },
  },
  [theme.breakpoints.down(900)]: {
    width: "100%",
    paddingInline: "20px",
  },
}));

const StyledButton = styled(Button)(({ theme }) => ({
  backgroundColor: "#121212",
  color: "#fefefe",
  padding: "8px 55px",
  borderRadius: "20px",
  fontSize: "16px",
  fontWeight: 500,
  lineHeight: "24px",
  textTransform: "none",
  marginTop: "20px",
  minWidth: "140px",
  "&:hover": {
    backgroundColor: "#333",
  },
}));
